import { createApi } from '@reduxjs/toolkit/query/react';
import {
  ArgsInitSliceMeta,
  ReferenceOfMeta,
  dynamicFetchBaseFactory,
} from '@vs/rtk/utils';
import { rtkCacheTTL } from '@vs/utils/constants';

const referenceOfMeta: ReferenceOfMeta = {
  _deployEnv: undefined,
  _baseUrl: undefined,
  _getTokenFunc: undefined,
};

export function initSliceMeta({
  deployEnv,
  getTokenFunc,
  baseUrl,
}: ArgsInitSliceMeta) {
  referenceOfMeta._deployEnv = deployEnv;
  referenceOfMeta._baseUrl = baseUrl;
  referenceOfMeta._getTokenFunc = getTokenFunc;
}

export const vsCommonApiBase = createApi({
  reducerPath: 'vsCommonGenApi',
  keepUnusedDataFor: rtkCacheTTL.long,
  refetchOnMountOrArgChange: rtkCacheTTL.long,
  baseQuery: dynamicFetchBaseFactory(referenceOfMeta),
  endpoints: () => ({}),
});
